import { FileContainer, process } from "am-tax-fe-core";
import { components } from "../generated/generated-api";
import { cachedApiUrl, client } from "../entities/entityApi";
import { uploadFile, uploadForm } from "../uploadUtils";

//#region Dto definition
export type Jurisdiction = components["schemas"]["JurisdictionDto"];
export type CreateJurisdiction = components["schemas"]["CreateOrUpdateJurisdictionDto"];
export type UpdateJurisdiction = components["schemas"]["CreateOrUpdateJurisdictionDto"] & { id: string };

export const getJurisdictionAsync = async (id: string): Promise<Jurisdiction> =>
    process(
        client().GET("/api/jurisdictions/{jurisdictionId}", {
            params: {
                path: {
                    jurisdictionId: id,
                },
            },
        }),
    );

export const getJurisdictionsAsync = async (): Promise<Jurisdiction[]> => process(client().GET("/api/jurisdictions"));

export const createJurisdictionAsync = async (args: CreateJurisdiction, file: FileContainer | undefined) => {
    const jurisdictionData: Record<string, string> = {
        Name: args.name,
        IntroductionDescription: args.introductionDescription || "",
        JurisdictionOverviewBlobPath: args.jurisdictionOverviewBlobPath || "",
        Abbreviation: args.abbreviation || "",
        Active: args.active?.toString() || "false",
        RegulatoryLanguage: args.regulatoryLanguage || "",
    };

    if (file !== undefined) {
        await uploadFile(`${cachedApiUrl}/api/jurisdictions`, file, jurisdictionData, "POST");
    } else {
        await uploadForm(`${cachedApiUrl}/api/jurisdictions`, jurisdictionData);
    }
};

export const updateJurisdictionAsync = async (args: UpdateJurisdiction, file: FileContainer | undefined) => {
    const jurisdictionData: Record<string, string> = {
        Name: args.name,
        IntroductionDescription: args.introductionDescription || "",
        JurisdictionOverviewBlobPath: args.jurisdictionOverviewBlobPath || "",
        Abbreviation: args.abbreviation || "",
        Active: args.active?.toString() || "false",
        RegulatoryLanguage: args.regulatoryLanguage || "",
    };

    if (file !== undefined) {
        await uploadFile(`${cachedApiUrl}/api/jurisdictions/${args.id}`, file, jurisdictionData, "PUT");
    } else {
        await uploadForm(`${cachedApiUrl}/api/jurisdictions/${args.id}`, jurisdictionData);
    }
};

export const deleteJurisdictionAsync = async (id: string): Promise<Jurisdiction> =>
    process(
        client().DELETE("/api/jurisdictions/{jurisdictionId}", {
            params: {
                path: {
                    jurisdictionId: id,
                },
            },
        }),
    );

export const uploadJurisdictionOverviewFile = async (file: FileContainer, jurisdictionId: string) => {
    return uploadFile(`${cachedApiUrl}/api/jurisdictions/${jurisdictionId}/overview`, file);
};
